import React from "react";

import Typography from "@/foundation/Typography/V2";

import { ActionButton } from "./style";

const LikeButton = ({
  isLiked,
  setIsLiked,
  count,
  height = 16,
  width = 16,
  iconMargin = "4px",
}) => {
  return (
    <ActionButton iconMargin={iconMargin} onClick={() => setIsLiked(!isLiked)}>
      <svg
        width={width}
        height={height}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={isLiked ? "active" : ""}
      >
        <path
          d="M9.51675 16.3416C9.23341 16.4416 8.76675 16.4416 8.48341 16.3416C6.06675 15.5166 0.666748 12.0749 0.666748 6.24159C0.666748 3.66659 2.74175 1.58325 5.30008 1.58325C6.81675 1.58325 8.15841 2.31659 9.00008 3.44992C9.84175 2.31659 11.1917 1.58325 12.7001 1.58325C15.2584 1.58325 17.3334 3.66659 17.3334 6.24159C17.3334 12.0749 11.9334 15.5166 9.51675 16.3416Z"
          stroke="#475467"
          strokeWidth="1.30374"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
      <Typography
        variant="label3"
        fontSize="14px"
        lineHeight="20px"
        fontFamily="var(--man-600)"
      >
        {count} Like{count > 1 ? `s` : ""}
      </Typography>
    </ActionButton>
  );
};

export default LikeButton;
